import { Component, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    standalone: true,
    selector: 'app-password-recovery-dialog',
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule
    ],
    template: `
    <div class="relative w-[300px] md:w-[400px] bg-white rounded-xl shadow p-6 pt-12 space-y-5 overflow-visible">

    <button
        (click)="dialogRef.close()"
        class="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-sm p-0 m-0 border-none rounded-full"
        aria-label="Cerrar"
        >
        <mat-icon>close</mat-icon>
    </button>

<h2 class="text-lg font-semibold text-gray-700">Recuperar contraseña</h2>

<mat-form-field appearance="outline" class="w-full" floatLabel="always">
  <mat-label>Email asociado a tu cuenta</mat-label>
  <input
    matInput
    [(ngModel)]="email"
    #emailInput="ngModel"
    type="email"
    name="email"
    required
    email
  >
  <mat-error *ngIf="emailInput.errors?.['email'] && emailInput.touched">
    Ingresá un email válido.
  </mat-error>
</mat-form-field>

<button
  mat-raised-button
  color="primary"
  class="w-full"
  (click)="enviar()"
  [disabled]="email.length < 3 || loading()"
>
  Enviar enlace de recuperación
</button>

<p *ngIf="mensaje()" class="text-sm text-green-700 text-center">{{ mensaje() }}</p>
<p *ngIf="error()" class="text-sm text-red-600 text-center">{{ error() }}</p>
</div>
  `
})
export class PasswordRecoveryDialog {
    dialogRef = inject(MatDialogRef<PasswordRecoveryDialog>);
    private authService = inject(AuthService);

    email = '';
    mensaje = signal('');
    error = signal('');
    loading = signal(false);

    enviar() {
        if (!this.email) return;
        this.loading.set(true);
        this.error.set('');
        this.mensaje.set('');

        this.authService.enviarRecuperacion(this.email)
            .then(() => {
                this.mensaje.set('Revisá tu bandeja de entrada para restablecer tu contraseña.');
                setTimeout(() => this.dialogRef.close(), 5000); // ✅ Cierre automático a los 5s
            })
            .catch(err => this.error.set(this.traducirError(err.code)))
            .finally(() => this.loading.set(false));
    }

    traducirError(code: string): string {
        switch (code) {
          case 'auth/invalid-email':
            return 'El email ingresado no es válido.';
          case 'auth/user-not-found':
            return 'No existe una cuenta con ese email.';
          default:
            return 'Ocurrió un error. Intentá nuevamente.';
        }
      }
}
